var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"toggle",attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.on},on:{"click":function($event){return _vm.$emit('change')}}}),_vm._v(" "),_c('label',{staticClass:"toggle-btn",attrs:{"data-tg-off":"關","data-tg-on":"開","for":_vm.id}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7e7ba28","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toggle.vue
// module id = 531
// module chunks = 1